var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.5C6.8 5.5 7 5.3 7 5C7 4.7 6.8 4.5 6.5 4.5C4 4.5 2 6.5 2 9C2 10.4 3.1 11.5 4.5 11.5C5.9 11.5 7 10.4 7 9C7 7.6 5.9 6.5 4.5 6.5C4.35 6.5 4.15 6.5 4 6.55C4.65 5.9 5.5 5.5 6.5 5.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5C11.35 6.5 11.15 6.5 11 6.55C11.65 5.9 12.5 5.5 13.5 5.5C13.8 5.5 14 5.3 14 5C14 4.7 13.8 4.5 13.5 4.5C11 4.5 9 6.5 9 9C9 10.4 10.1 11.5 11.5 11.5C12.9 11.5 14 10.4 14 9C14 7.6 12.9 6.5 11.5 6.5Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.5c49ffb51ae10f05000103f863e41457.svg";
export { ForwardRef as ReactComponent };